import { fetchHasOpgenieAccount } from './fetch-has-opsgenie-account';

export const actions = {
	fetchHasOpgenieAccount,
} as const;

export type Actions = typeof actions;
